import { cn } from "../lib/utils";

type AppOwnership = "personal" | "contributed";

const ownershipStyles: Record<AppOwnership, { label: string; className: string }> = {
  personal: {
    label: "Personal",
    className: "border-emerald-400/30 bg-emerald-400/10 text-emerald-300",
  },
  contributed: {
    label: "Contributed",
    className: "border-sky-400/30 bg-sky-400/10 text-sky-300",
  },
};

type AppOwnershipBadgeProps = {
  ownership: AppOwnership;
  className?: string;
};

export default function AppOwnershipBadge({ ownership, className }: AppOwnershipBadgeProps) {
  const style = ownershipStyles[ownership];

  return (
    <span
      className={cn(
        "inline-flex w-fit items-center rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em]",
        style.className,
        className
      )}
    >
      {style.label}
    </span>
  );
}
